import Vue from "vue"
import VueRouter from "vue-router"
import store from './store.js'

//Auth components
import Login from './components/auths/Login.vue'
import Register from './components/auths/Register.vue'
import ForgotPassword from './components/auths/ForgotPassword.vue'
import RequestPin from './components/auths/RequestPin.vue'

//Dashboard compoent
import Dashboard from './components/dashboards/Main.vue'

//Contact and contact related components
import Contact from './components/contacts/Main.vue'
import CreateBusiness from './components/contacts/CreateBusiness.vue'
import CreatePerson from './components/contacts/CreatePerson.vue'
import EditBusiness from './components/contacts/EditBusiness.vue'
import EditPerson from './components/contacts/EditPerson.vue'

//Invoice and related components
import Invoice from './components/invoices/Main.vue'
import CreateInvoice from './components/invoices/CreateInvoice.vue'
import InvoiceDetails from './components/invoices/InvoiceDetails.vue'
import SelectContactFromList from './components/invoices/SelectContactFromList.vue'
import SelectItemFromList from './components/invoices/SelectItemFromList.vue'
import SelectAccountFromList from './components/invoices/SelectAccountFromList.vue'
import EditInvoice from './components/invoices/EditInvoice.vue'
import SelectPayment from './components/invoices/SelectPayment.vue'
import SelectPaymentMethod from './components/invoices/SelectPaymentMethod.vue'
import SelectPaymentAccount from './components/invoices/SelectPaymentAccount.vue'
import ViewInvoicePDF from './components/invoices/ViewInvoicePDF'
import CreateInvoiceTest from './components/invoices/CreateInvoiceTest.vue'


//Invoice Personalization
import Personalization from './components/invoices/Personalization.vue'

//Invoice Review
import InvoicePreview from './components/invoices/Preview.vue'

//Item and related components
import Item from './components/items/Main.vue'
import CreateNewItem from './components/items/CreateNewItem.vue'
import EditItem from './components/items/EditItem.vue'

Vue.use(VueRouter)

let router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "dashboard",
            component: Dashboard,
            meta: {
                requiresAuth: true,
                title: 'Dashboard'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresAuth: false,
                title: 'Login'
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                requiresAuth: false,
                title: 'Enter Business Info'
            }
        },
        {
            path: "/invoices/:cat",
            name: "invoice",
            component: Invoice,
            meta: {
                requiresAuth: true,
                title: 'Invoices'
            }
        },
        {
            path: "/create_invoice",
            name: "create_invoice",
            component: CreateInvoice,
            meta: {
                requiresAuth: true,
                title: 'New Invoice'
            }
        },

        {
            path: "/create_invoice_test",
            name: "create_invoice_test",
            component: CreateInvoiceTest,
            meta: {
                requiresAuth: true,
                title: 'New Invoice Test'
            }
        },
        {
            path: "/edit_invoice/:id",
            name: "edit_invoice",
            component: EditInvoice,
            meta: {
                requiresAuth: true,
                title: 'Edit Invoice'
            }
        },
        {
            path: "/invoice_details",
            name: "invoice_details",
            component: InvoiceDetails,
            meta: {
                requiresAuth: true,
                title: 'Invoice Details'
            }
        },
        {
            path: "/invoice_personalization",
            name: "invoice_personalization",
            component: Personalization,
            meta: {
                requiresAuth: true,
                title: 'Invoice Personalization'
            }
        },
        {
            path: "/invoice_preview",
            name: "invoice_preview",
            component: InvoicePreview,
            meta: {
                requiresAuth: true,
                title: 'Invoice Preview'
            }
        },
        {
            path: "/select_contact/:cat",
            name: "select_contact",
            component: SelectContactFromList,
            meta: {
                requiresAuth: true,
                title: 'Select Contact From List'
            }
        },
        {
            path: "/method",
            name: "select_method",
            component: SelectPaymentMethod,
            meta: {
                requiresAuth: true,
                title: 'Select Payment Method'
            }
        },
        {
            path: "/account",
            name: "select_account",
            component: SelectPaymentAccount ,
            meta: {
                requiresAuth: true,
                title: 'Add Deposit To'
            }
        },
        {
            path: "/select_item",
            name: "select_item",
            component: SelectItemFromList,
            meta: {
                requiresAuth: true,
                title: 'Select Item From List'
            }
        },

        {
            path: "/select_account",
            name: "select_account",
            component: SelectAccountFromList,
            meta: {
                requiresAuth: true,
                title: 'Select Account From List'
            }
        },
        {
            path: "/select_payment",
            name: "select_payment_method",
            component: SelectPayment,
            meta: {
                requiresAuth: true,
                title: 'New Payment Line'
            }

        },
        {
            path: "/contacts/:cat",
            name: "contact",
            component: Contact,
            meta: {
                requiresAuth: true,
                title: 'Contacts'
            }
        },
        {
            path: "/edit_business/:cat",
            name: "edit_business",
            component: EditBusiness,
            meta: {
                requiresAuth: true,
                title: 'Edit Business'
            }
        },
        {
            path: "/edit_person/:cat",
            name: "edit_person",
            component: EditPerson,
            meta: {
                requiresAuth: true,
                title: 'Edit Person'
            }
        },
        {
            path: "/create_business",
            name: "createBusiness",
            component: CreateBusiness,
            meta: {
                requiresAuth: true,
                title: 'New Business'
            }
        },
        {
            path: "/create_person",
            name: "createPerson",
            component: CreatePerson,
            meta: {
                requiresAuth: true,
                title: 'New Person'
            }
        },
        {
            path: "/items/:cat",
            name: "item",
            component: Item,
            meta: {
                requiresAuth: true,
                title: 'Items'
            }
        },
        {
            path: "/create_item",
            name: "create_item",
            component: CreateNewItem,
            meta: {
                requiresAuth: true,
                title: 'New Item'
            }
        },
        {
            path: "/edit_item/:id",
            name: "edit_item",
            component: EditItem,
            meta: {
                requiresAuth: true,
                title: 'Edit Item',
            }
        },
        {
            path: "/forgotPassword",
            name: "forgotPassword",
            component: ForgotPassword,
            meta: {
                requiresAuth: false,
                title: 'Forgot Password',
            }
        },
        {
            path: "/requestPin",
            name: "requestPin",
            component: RequestPin,
            meta: {
                requiresAuth: false,
                title: 'Request PIN',
            }
        },
        {
            path: "/preview_pdf",
            name: "preview_pdf",
            component: ViewInvoicePDF,
            meta: {
                requiresAuth: true,
                title: 'View Invoice'
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['auth/isLoggedIn']) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})

export default router
